// extracted by mini-css-extract-plugin
module.exports = {"dots":"light_dots__QyepX"};